import React, { useEffect } from 'react';
import styles from './ContactPage.module.css'; // Import module-specific styles
import MainLayout from '../../Layout/MainLayout';
import icon1 from '../../Assets/Contact/Icon1.png'; // Import asset images and icons
import icon2 from '../../Assets/Contact/Icon2.png';
import icon3 from '../../Assets/Contact/Icon3.png';

const ContactPage = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to the top of the page when the component mounts
    }, []);

    return (
        <MainLayout> {/* Wrapper component for main layout structure */}
            <div className={styles.contact}>
                <div className={styles.contact1}>
                    <h1>Get in touch with us</h1>
                    <div className={styles.contact1Bottom}>
                        {/* Contact form section */}
                        <div className={styles.contact1BLeft}>
                            <h3>Drop us a message</h3>
                            <p className="pLarge">We will get back to you as soon as possible.</p>
                            <div className={styles.contact1BLForm}>
                                {/* Form inputs for user details */}
                                <input type="text" name="fullname" placeholder="Full Name" />
                                <input type="text" name="companyname" placeholder="Company Name" />
                            </div>
                            <input type="text" name="workemail" placeholder="Work Email" />
                            <input type="text" name="subject" placeholder="Subject" />
                            <textarea name="message" placeholder="Message" style={{ resize: 'none' }} />
                            <button>Send</button>
                        </div>
                        {/* Contact information section */}
                        <div className={styles.contact1BRight}>
                            <div className={styles.contact1BItem}>
                                <img src={icon1} alt="Phone icon" />
                                <div className={styles.contact1BTText}>
                                    <h4>+ 1800 145 276</h4>
                                    <p>Free support</p>
                                </div>
                            </div>
                            <div className={styles.contact1BItem}>
                                <img src={icon2} alt="Email icon" />
                                <div className={styles.contact1BTText}>
                                    <h4>finsweet@gmail.com</h4>
                                    <p>Help Email support</p>
                                </div>
                            </div>
                            <div className={styles.contact1BItem}>
                                <img src={icon3} alt="Sales icon" />
                                <div className={styles.contact1BTText}>
                                    <h4>sales@finsweet.com</h4>
                                    <p>Sales Enquiry</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
}

export default ContactPage;
